import React from 'react'
import { useIntl } from 'react-intl'

import type { GenericErrorProps } from '../../../../../../core/screens/GenericError'
import { ShelfErrorState } from '../ShelfErrorState'

type CollectionsShelfErrorStateProps = GenericErrorProps

export const CollectionsShelfErrorState = (
  props: CollectionsShelfErrorStateProps
) => {
  const { formatMessage } = useIntl()

  return (
    <ShelfErrorState
      data-testid="collections-shelf-error-state"
      title={formatMessage({ id: 'collectionsShelfErrorStateTitle' })}
      description={formatMessage({
        id: 'collectionsShelfErrorStateDescription',
      })}
      workflowType="collections-shelf-error"
      {...props}
    />
  )
}
